'use strict';

export default class SearchFilter extends React.Component {
    render() {
        const {type, filters, counters, onSetFilter} = this.props;

        const items = type === 'planes' ? {
            br: tMsg('Самолеты'),
            pl: tMsg('Готовые предложения'),
            el: 'Empty Legs',
        } : {
            st: 'Shuttle',
            js: 'Sharing',
            dl: 'Deals',
            dc: tMsg('Скидки'),
        };

        return <div className="filter">
            {Object.keys(items).map(item => {
                const key = `searchFilter${item}`
                const checked = counters[item] > 0 && filters[item] === true;
                return <div key={key} className={['checkbox2', !counters[item] && 'disabled'].join(' ')}>
                    <input type="checkbox" id={`${item}Cb`} checked={checked} onChange={() => onSetFilter(item, !checked)}/>
                    <label htmlFor={`${item}Cb`}>
                        <span>{items[item]} <sup>{!!counters[item] ? counters[item] : 0}</sup></span>
                    </label>
                </div>
            })}
        </div>
    }
}
